import React from 'react';
import ChatIcon from './ChatIcon';
import { useChatTheme } from './chatThemes';
import accessGeniusLogo from '../../styles/assets/img/chat/accessgenius-logo.svg';
import loadingDot from '../../styles/assets/img/chat/loading-dot.svg';
import botTail from '../../styles/assets/img/chat/bubble-tail-bot.svg';
import userTail from '../../styles/assets/img/chat/bubble-tail-user.svg';

/** Speech bubble with the design's tail: bottom-left for the bot, bottom-right for the user. */
export function ChatBubble({ from = 'bot', className = '', children, ...rest }) {
    return (
        <div className={`chat-bubble chat-bubble-${from} ${className}`} {...rest}>
            {children}
            {from === 'user'
                // Masked so the tail matches the skin's user-bubble color
                ? <ChatIcon src={userTail} className="chat-bubble-tail" />
                : <img className="chat-bubble-tail" src={botTail} alt="" aria-hidden="true" />}
        </div>
    );
}

/** Genie lamp illustration used in the launcher and the intro card. */
export function ChatLamp() {
    const { assets } = useChatTheme();
    return (
        <span className="chat-lamp" aria-hidden="true">
            <img src={assets.lamp} alt="" />
        </span>
    );
}

/** "Powered by AccessGenius®" line. */
export function ChatPoweredBy() {
    return (
        <div className="chat-powered-by">
            <span>Powered by</span>
            <span className="chat-powered-by-logo">
                <img src={accessGeniusLogo} alt="AccessGenius" />
                <span className="chat-powered-by-reg" aria-hidden="true">®</span>
            </span>
        </div>
    );
}

/** Three pulsing dots shown in a bot bubble while the assistant is thinking. */
export function ChatLoadingDots() {
    return (
        <div className="chat-message-row chat-message-row-bot">
            <ChatBubble className="chat-bubble-loading" role="status" aria-label="Assistant is thinking">
                <div className="chat-loading-dots">
                    <ChatIcon src={loadingDot} className="chat-loading-dot" />
                    <ChatIcon src={loadingDot} className="chat-loading-dot" />
                    <ChatIcon src={loadingDot} className="chat-loading-dot" />
                </div>
            </ChatBubble>
        </div>
    );
}
